export class FileReference {
  id: string;
  name: string;
  fileName: string;
  path: string;
  creationTime: Date;
  bucketName: string;
  creatorID: string;
  kind: number;
  objectID: string;
}
